<!-- Landing page navigation -->
<div class="logo" *ngIf="isNewUser; else showLandingPage">
  <img src="./assets/img/logo.png" width="130px" />
</div>

<ng-template #showLandingPage>
  <div class="logo">
    <a id="landing" href="#/app/landing">
      <img src="./assets/img/cargoes.png" width="130px" />
    </a>
  </div>
</ng-template>

<div class="alain-default__nav-wrap float-right ">
  <header-notify class="header-notify-wrap"></header-notify>
  <ul nz-menu class="alain-default__nav">
    <!-- <header-search class="alain-default__search" [toggleChange]="searchToggleStatus"></header-search> -->
    <!-- Notify moved outside nz-menu -->
    <li class="mob-hide">
      <header-default-company></header-default-company>
    </li>
    <li class="hidden-mobile" *ngIf="showLangugeMenuAfterLogin">
      <div class="alain-default__nav-item">
        <!--<header-i18n showLangText="false" class="langs"></header-i18n>-->
      </div>
    </li>
    <li class="header-user-li">
      <header-user></header-user>
    </li>
    <!-- <li nz-menu-item><a (click)="login()">Login</a></li> -->
  </ul>
</div>
